import { useLicensingServiceV1 } from "@rw1/api-services";
import { Licensing_V1 } from "@rw1/auto-generated-clients";
import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from "@tanstack/react-query";
import { WHITELIST_BY_LICENSE_ID_QUERY_KEY } from "./useWhitelistByLicenseId";

export interface UseAddWhitelistedEmailsProps {
  licenseId: string;
  emails: string[];
  onSuccess?: () => void;
}

export const useAddWhitelistedEmails = (): UseMutationResult<
  void,
  Error,
  UseAddWhitelistedEmailsProps
> => {
  const licensingService = useLicensingServiceV1();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ licenseId, emails }: UseAddWhitelistedEmailsProps) => {
      return await licensingService.addEmailsToLicenseWhitelist(
        licenseId,
        emails,
      );
    },
    onSuccess: (_, variables) => {
      queryClient.setQueryData(
        [WHITELIST_BY_LICENSE_ID_QUERY_KEY, variables.licenseId],
        (oldData: Licensing_V1.WhitelistEntry[] | undefined) => {
          const newEntries = variables.emails.map(
            (email) =>
              new Licensing_V1.WhitelistEntry({
                email,
                createdAt: new Date(),
              }),
          );

          return oldData ? [...oldData, ...newEntries] : newEntries;
        },
      );
      void queryClient.invalidateQueries({
        queryKey: [WHITELIST_BY_LICENSE_ID_QUERY_KEY, variables.licenseId],
      });
      variables.onSuccess?.();
    },
  });
};
